var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","tile":""}},[_c('crud',{attrs:{"label":"Diagnoses","model":"PatientDiagnosis","headers":_vm.diagnoses,"conditions":[{patient_id:{eq:this.$route.params.id}}]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }